module.exports = __webpack_public_path__ + "ef1f65378cdaea3bc6a0dddfeb9d0de9.svg";